import {ManageWorkflowTemplate} from './Custom/ManageWorkflow';

export const TEMPLATE_NAMES = Object.freeze({
  MANAGE_WORKFLOW: 'manageWorkflow',
});

export const TEMPLATE_COMPONENTS = Object.freeze({
  [TEMPLATE_NAMES.MANAGE_WORKFLOW]: ManageWorkflowTemplate,
});
